import IMask from "imask/holder";
import moment from "moment";
import { IPropsData } from 'shared/components/WrapperFormRow/WrapperFormRow'

export const FormDataFioPersonal = [
    [
        {
            name: "contact.first_name",
            label: "Имя", 
            placeholder: "Имя", 
            type: "text",
            disabled: false,
            required: true,
        },
        {
            name: "contact.surname",
            label: "Фамилия", 
            placeholder: "Фамилия", 
            type: "text",
            disabled: false,
            required: true,
        },
        {
            name: "contact.patronymic",
            label: "Отчество", 
            placeholder: "Отчество", 
            type: "text",
            disabled: false,
        },
    ]
];

export const FormDataGeneralPersonal = [
    [
        {
            name: "phone",
            label: "Телефон", 
            placeholder: "Телефон", 
            type: "text",
            disabled: false,
            required: true,
            maskConfig: {
                mask: '+{7}-000-000-00-00'
            }
        },
        {
            name: "email",
            label: "Почта", 
            placeholder: "Почта", 
            type: "email",
            disabled: false,
            required: true,
        },
        {
            name: "created_at",
            label: "Дата регистрации", 
            placeholder: "Дата регистрации", 
            type: "text",
            disabled: true,
            required: true,
        },
        {
            name: "discount",
            label: "Постоянная скидка (%)", 
            placeholder: "Постоянная скидка (%)", 
            type: "text",
            disabled: true,
            required: true,
            maskConfig: {
                mask: Number,
                min: 0,
                max: 100,
            }
        },
    ]
]

export const FormDataDocumentsPersonal = [
    [
        {
            name: "additional_data.documents.serial",
            label: "Серия и номер", 
            placeholder: "Серия и номер", 
            type: "text",
            disabled: false,
            maskConfig: {
                mask: '0000 000000'
            }
        },
        {
            name: "additional_data.documents.issue_date",
            label: "Дата выдачи", 
            placeholder: "Дата выдачи", 
            type: "text",
            disabled: false,
            maskConfig: {
                mask: Date,
                pattern: 'd{.}`m{.}`Y',
                blocks: {
                    d: {
                        mask: IMask.MaskedRange,
                        from: 1,
                        to: 31,
                        maxLength: 2,
                    },
                    m: {
                        mask: IMask.MaskedRange,
                        from: 1,
                        to: 12,
                        maxLength: 2,
                    },
                    Y: {
                        mask: IMask.MaskedRange,
                        from: 1945,
                        to: moment().format("YYYY"),
                        maxLength: 4,
                    },
                }
            }
        },
        {
            name: "additional_data.documents.division_code",
            label: "Код подразделения", 
            placeholder: "Код подразделения", 
            type: "text",
            disabled: false,
            maskConfing: {
                mask: '000-000'
            }
        },
        {
            name: "additional_data.documents.issued_by",
            label: "Кем выдан", 
            placeholder: "Кем выдан", 
            type: "text",
            disabled: false,
            maskConfig: {
                mask: /^[A-Za-zА-Яа-яЁё\s]*$/
            }
        },
    ]
]

export const FormDataPlacePersonal = [
    [
        {
            name: "additional_data.documents.city",
            label: "Город", 
            placeholder: "Город", 
            type: "text",
            disabled: false,
            maskConfig: {
                mask: /^[A-Za-zА-Яа-яЁё\s]*$/
            }
        },
        {
            name: "additional_data.documents.street",
            label: "Улица", 
            placeholder: "Улица", 
            type: "text",
            disabled: false
        },
        {
            name: "additional_data.documents.house_number",
            label: "Дом", 
            placeholder: "Дом", 
            type: "text",
            disabled: false,
        },
        {
            name: "additional_data.documents.apartment_number",
            label: "Квартира", 
            placeholder: "Квартира", 
            type: "text",
            disabled: false,
            maskConfig: {
                mask: Number
            }
        },
        {
            name: "additional_data.documents.index",
            label: "Индекс", 
            placeholder: "Индекс", 
            type: "text",
            disabled: false,
            maskConfig: {
                mask: Number
            }
        },
    ]
]

export const FormDataGeneralCompany = [
    [
        {
            name: "additional_data.documents.organization_name",
            label: "Наименование", 
            placeholder: "Наименование", 
            type: "text",
            disabled: false,
            required: true,
        },
        {
            name: "additional_data.documents.inn",
            label: "ИНН", 
            placeholder: "ИНН", 
            type: "text",
            disabled: false,
            required: true,
            maskConfig: {
                mask: Number,
            }
        },
        {
            name: "additional_data.documents.kpp",
            label: "КПП", 
            placeholder: "КПП", 
            type: "text",
            disabled: false,
            maskConfig: {
                mask: Number,
            }
        },
        {
            name: "created_at",
            label: "Дата регистрации", 
            placeholder: "Дата регистрации", 
            type: "text",
            disabled: true,
            maskConfig: {
                mask: Number,
            }
        },
    ],
    [
        {
            name: "additional_data.documents.bank_name",
            label: "Название банка", 
            placeholder: "Название банка", 
            type: "text",
            disabled: false,
        },
        {
            name: "additional_data.documents.bik",
            label: "БИК банка", 
            placeholder: "БИК банка", 
            type: "text",
            disabled: false,
        },
        {
            name: "additional_data.documents.checking_account",
            label: "Расчетный счет", 
            placeholder: "Расчетный счет", 
            type: "text",
            disabled: false,
        },
        {
            name: "additional_data.documents.correspondent_account",
            label: "Кореспонденческий счет", 
            placeholder: "Кореспонденческий счет", 
            type: "text",
            disabled: false,
        },
    ],
    [
        {
            name: "phone",
            label: "Телефон", 
            placeholder: "Телефон", 
            type: "text",
            disabled: false,
            required: true,
        },
        {
            name: "email",
            label: "Почта", 
            placeholder: "Почта", 
            type: "text",
            disabled: false,
            required: true,
        },
        {
            name: "additional_data.documents.legal_address",
            label: "Юридический адрес", 
            placeholder: "Юридический адрес", 
            type: "text",
            disabled: false,
            required: true,
        },
        {
            name: "discount",
            label: "Постоянная скидка (%)", 
            placeholder: "Постоянная скидка (%)", 
            type: "text",
            disabled: false,
            maskConfig: {
                mask: Number,
                min: 0,
                max: 100,
            }
        },
    ]
];

export const FormDataContactsCompany = (buttons: IPropsData[]) => ([
    [
        {
            name: "first_name",
            label: "Имя", 
            placeholder: "Имя", 
            type: "text",
            disabled: false,
            required: true,
        },
        {
            name: "patronymic",
            label: "Отчество", 
            placeholder: "Отчество", 
            type: "text",
            disabled: false,
        },
        {
            name: "surname",
            label: "Фамилия", 
            placeholder: "Фамилия", 
            type: "text",
            disabled: false,
            required: true,
        },
        {
            name: "phone",
            label: "Телефон", 
            placeholder: "Телефон", 
            type: "text",
            disabled: false,
        },
        {
            name: "email",
            label: "Почта", 
            placeholder: "Почта", 
            type: "text",
            disabled: false,
            required: true,
        },
        ...buttons,
    ]
]);
